function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 1C15.4399 1 11.9598 2.05568 8.99974 4.03355C6.03966 6.01141 3.73255 8.82263 2.37018 12.1117C1.0078 15.4008 0.651339 19.02 1.34587 22.5116C2.04041 26.0033 3.75474 29.2106 6.27209 31.7279C8.78943 34.2453 11.9967 35.9596 15.4884 36.6541C18.98 37.3487 22.5992 36.9922 25.8883 35.6298C29.1774 34.2674 31.9886 31.9603 33.9665 29.0003C35.9443 26.0402 37 22.5601 37 19C37 14.2261 35.1036 9.64773 31.7279 6.27208C28.3523 2.89642 23.7739 1 19 1Z",
  stroke: "black",
  strokeWidth: 1.91667,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2725 13.5099C13.2725 13.5099 13.3584 11.7202 15.2739 10.1789C16.4102 9.26356 17.7725 8.99868 18.9997 8.98027C20.1176 8.96595 21.1158 9.15106 21.713 9.43538C22.7358 9.9222 24.727 11.1106 24.727 13.6378C24.727 16.2969 22.9884 17.5047 21.0073 18.8332C19.0263 20.1617 18.4884 21.6038 18.4884 23.0939",
  stroke: "black",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3863 30.4552C19.5159 30.4552 20.4317 29.5394 20.4317 28.4097C20.4317 27.28 19.5159 26.3643 18.3863 26.3643C17.2566 26.3643 16.3408 27.28 16.3408 28.4097C16.3408 29.5394 17.2566 30.4552 18.3863 30.4552Z",
  fill: "black"
});

var SvgHelpOutline = function SvgHelpOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelpOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help-outline.bc9d663d.svg";
export { ForwardRef as ReactComponent };